import styled from 'styled-components';
import { smallMediaQuery } from '../../common/utilities/sizeHelpers';

export const WeatherDetailsListItem = styled.li`
    white-space: nowrap;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;
`;

export const WeatherDetailsCellValue = styled.span`
    margin-left: 8px;
    color: #435560;
    font-size: 15px;
    font-weight: 400;
`;

export const WeatherDetailsCellLabel = styled.span`
    width: auto;
    color: #888888;
    font-size: 15px;
    font-weight: 400;
`;

export const WeatherDetailsCellContainerRight = styled.div`
    width: 58%;
    @media(${smallMediaQuery}) {
        width: 55%;
    };
`;

export const WeatherDetailsCellContainerLeft = styled.div`
    width: 42%;
    @media(${smallMediaQuery}) {
        width: 45%;
    };
`;
